module.exports = __webpack_public_path__ + "assets/026d31e416f5ae8b4261df937c62313c.png";